import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import SmsSendOtpOutputComponent from '../output/SmsSendOtpOutputComponent';

// DLT template default — wired here so the registered DLT template
// pre-fills on page load. User can still override per-call. Airtel DLT
// approved Service Implicit template under PE 1001132739449770807,
// sender ID "HIRSPL". Delivered via MSG91.
// MSG91 uses their OWN internal template ID (24-char hex), NOT the raw Airtel
// DLT template ID. The MSG91 internal ID wraps the DLT template registered on
// MSG91's portal (see MSG91 dashboard → Templates).
const DEFAULT_DLT_TEMPLATE_ID = '6a4dee114ab8e9484f0bbe93';

const SmsSendOtpInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-send', title: 'SMS Send OTP', subtitle: 'Send a one-time password to a mobile number via MSG91' }}
        fields={[
            { name: 'templateId', label: 'DLT Template ID', icon: 'pi-id-card', placeholder: DEFAULT_DLT_TEMPLATE_ID, default: DEFAULT_DLT_TEMPLATE_ID, maxLength: 30, mono: true },
            { name: 'mobile', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
        ]}
        endpoint={{
            path: '/surepass/sms/send-otp',
            bodyMapper: (v, sid) => ({ template_id: v.templateId.trim(), mobile: v.mobile, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="sms-send-otp"
        submitLabel="Send OTP"
        successSummary="OTP sent"
        errorSummary="OTP send failed"
        confirmHeader="Confirm OTP send"
        confirmAcceptLabel="Yes, send"
        // Custom output: surfaces client_id prominently + one-click navigation
        // to the verify page with prefilled client_id. See output component for why.
        outputComponent={SmsSendOtpOutputComponent}
    />
);

export default SmsSendOtpInputComponent;
